import GoogleLogo from "../assets/google-logo.png";
import FacebookLogo from "../assets/facebook-logo.png";

export const getGoogleUrl = (state) => {
  if (state === "GOOGLE") {
    const rootUrl = `https://accounts.google.com/o/oauth2/v2/auth`;

    let baseUrl;
    if (process.env.REACT_APP_ENV === "development") {
      baseUrl = "http://localhost:3000";
    } else if (process.env.REACT_APP_ENV === "production") {
      baseUrl = "https://frontend.inaepclub.ba";
    } else if (process.env.REACT_APP_ENV === "test") {
      baseUrl = "https://frontend-loyalty-test.ipc.hr";
    }

    const googleOptions = {
      redirect_uri: `${baseUrl}/socialNetworkOauth`,
      client_id:
        "92250147622-9etbc9nqdevq817q0d4vrqnd9jbjtt1o.apps.googleusercontent.com",
      access_type: "offline",
      response_type: "code",
      prompt: "consent",
      scope: [
        "https://www.googleapis.com/auth/userinfo.profile",
        "https://www.googleapis.com/auth/userinfo.email",
      ].join(" "),
      state: state,
    };

    const qs = new URLSearchParams(googleOptions);

    const result = `${rootUrl}?${qs.toString()}`;

    return result;
  } else if (state === "FACEBOOK") {
    const rootUrl = "https://www.facebook.com/v19.0/dialog/oauth";

    let baseUrl;
    if (process.env.REACT_APP_ENV === "development") {
      baseUrl = "http://localhost:3000";
    } else if (process.env.REACT_APP_ENV === "production") {
      baseUrl = "https://frontend.inaepclub.ba";
    } else if (process.env.REACT_APP_ENV === "test") {
      baseUrl = "https://frontend-loyalty-test.ipc.hr";
    }

    const facebookOptions = {
      redirect_uri: `${baseUrl}/socialNetworkOauth`,
      client_id: "2240074909657462",

      state: state,
    };

    const qs = new URLSearchParams(facebookOptions);

    const result = `${rootUrl}?${qs.toString()}`;

    return result;
  }
};

const SignInSocialMNetwork = ({ type }) => {
  const styles = {
    googleButton: {
      width: "100%",
      padding: "0.5em",
      transition: "background-color 0.15s ease",
      cursor: "pointer",
      fontSize: "19px",
      marginTop: "1.5em",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: "1em",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
      backgroundColor: "white",
      border: 0,
    },
    facebookButton: {
      width: "100%",
      padding: "0.5em",
      transition: "background-color 0.15s ease",
      cursor: "pointer",
      fontSize: "19px",
      marginTop: "1.5em",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: "1em",
      backgroundColor: "#0866ff",
      border: 0,
    },
  };

  if (type.toUpperCase() == "GOOGLE") {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <button
            style={styles.googleButton}
            onClick={() => {
              window.location.href = getGoogleUrl(type.toUpperCase());
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <img src={GoogleLogo} style={{ width: 20 }} />
            </div>
            <p
              style={{
                flex: 2.3,
                margin: 0,
                textAlign: "left",
                color: "black",
              }}
            >
              Prijavi se s {type}om
            </p>
          </button>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <button
            style={styles.facebookButton}
            onClick={() => {
              window.location.href = getGoogleUrl(type.toUpperCase());
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <img src={FacebookLogo} style={{ width: 20 }} />
            </div>
            <p
              style={{
                flex: 2.3,
                margin: 0,
                textAlign: "left",
                color: "white",
              }}
            >
              Prijavi se s {type}om
            </p>
          </button>
        </div>
      </>
    );
  }
};

export default SignInSocialMNetwork;

{
  /* <BaseButton
        onClick={() => {
          window.location.href = getGoogleUrl(type.toUpperCase());
        }}
        translate={false}
      >
        {type}
      </BaseButton> */
}
